/*
akcent 9F5965
glowny kolor

akcent2 CB7A89
podswietlanie najechanie


tlo B4BEB8
hero tlo 


spotlight FBFBEF
karta

spotlight2 C5D1CA
niewiem


EEF7F2
*/

export const lightTheme = {
  colors: {
    primary: "#9F5965",
    secondary: "#89928d",
    background: "#FBFBEF",
    modalBackground: "#FBFBEF",
    cardBackground: "#C5D1CA",
    textColor: "#2e2e2e", // Darker text for light theme
    heroBackground: "#B4BEB8", // Light gray background for hero section
  },
};

export const darkTheme = {
  colors: {
    primary: "#953C4F",
    secondary: "#393637",
    background: "#393637", // Dark gray background
    modalBackground: "#1e1e1e", // Dark gray background
    cardBackground: "#2c2c2c", // Darker gray background
    textColor: "#e0e0e0", // Lighter text for readability in dark mode
    heroBackground: "#B4BEB8",
  },
};
